export const getStatusBadgeStyle = (status) => {
  const base = {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "none",
    whiteSpace: "nowrap",
  };

  const map = {
    present: {
      background: "#b9fbc0",
      color: "#087e2a",
    },
    absent: {
      background: "#ffd6d6",
      color: "#d7263d",
    },
    late: {
      background: "#fff2cc",
      color: "#b26a00",
    },
    rest_day: {
      background: "#e0e7ff",
      color: "#3730a3",
    },
    restDay: {
      background: "#e0e7ff",
      color: "#3730a3",
    },
    "Rest Day": {
      background: "#e0e7ff",
      color: "#3730a3",
    },
    holiday: {
      background: "#ffe0f0",
      color: "#c026d3",
    },
    leave: {
      background: "#d1c4e9",
      color: "#512da8",
    },
    onLeave: {
      background: "#d1c4e9",
      color: "#512da8",
    },
    on_leave: {
      background: "#d1c4e9",
      color: "#512da8",
    },
    "On Leave": {
      background: "#d1c4e9",
      color: "#512da8",
    },
    half_day: {
      background: "#ffe4b5",
      color: "#b45309",
    },
  };

  return { ...base, ...(map[status] || { background: "#e0e7ef", color: "#334155" }) };
};

export const getStatusText = (status, language) => {
  const labels = {
    en: {
      present: "Present",
      absent: "Absent",
      late: "Late",
      onLeave: "On Leave",
      on_leave: "On Leave",
      "On Leave": "On Leave",
      restDay: "Rest Day",
      rest_day: "Rest Day",
      "Rest Day": "Rest Day",
      holiday: "Holiday",
      leave: "On Leave",
      half_day: "Half Day",
    },
    ar: {
      present: "حاضر",
      absent: "غائب",
      late: "متأخر",
      onLeave: "في إجازة",
      on_leave: "في إجازة",
      "On Leave": "في إجازة",
      restDay: "يوم راحة",
      rest_day: "يوم راحة",
      "Rest Day": "يوم راحة",
      holiday: "عطلة",
      leave: "في إجازة",
      half_day: "نصف يوم",
    },
  };

  const lang = language === "ar" ? "ar" : "en";
  return labels[lang][status] || status || "-";
};